import React, { useEffect, useState } from "react"
import { NavLink, useNavigate, useParams } from "react-router-dom"
import { MdOutlineFileDownload } from "react-icons/md"
import { toast } from "react-toastify"
import styles from "../ReportDataNote/reportDataNote.module.css"
import Button from "../../components/Form/Button"
import DatePicker from "../../components/Form/DatePicker"
import FormGroup from "../../components/Form/FormGroup"
import Select from "../../components/Form/Select"
import Loading from "../layouts/Loading"
import api from "../../services/api"
import { useData } from "../../contexts/dataContext"
import { getUsersBySelectedTeams, getValidUserIdsByTeams } from "../../utils/utils"
import { initialTaskFilters, taskStatusOptions } from "../Tasks/filters"

const ReportDataTask = () => {
    const [filters, setFilters] = useState(initialTaskFilters)
    const [loading, setLoading] = useState(false)
    const { account_id } = useParams()
    const navigate = useNavigate()
    const { teams, users, typesTask } = useData()

    useEffect(() => {
        setFilters(previous => ({
            ...previous,
            teams: teams?.map(team => team.id) || [],
            users: getUsersBySelectedTeams(teams?.map(team => team.id), users, teams).map(user => user.id),
            typesTask: typesTask?.map(type => type.id) || [],
        }))
    }, [teams, users, typesTask])

    const changeFilter = (name, value) => {
        setFilters(previous => ({
            ...previous,
            [name]: value,
            ...(name === "teams" ? { users: getValidUserIdsByTeams(previous.users, value, users, teams, [], previous.teams) } : {}),
        }))
    }

    const submit = async () => {
        try {
            setLoading(true)
            const payload = Object.fromEntries(Object.entries(filters).map(([key, value]) => [key, Array.isArray(value) ? value.join(",") : value]))
            const response = await api.post("/reports/tasks", payload)
            toast.success(response.data?.message)
            navigate(`/${account_id}/reports/log`)
        } catch (err) {
            toast.error(err?.response?.data?.message || "Não foi possível solicitar o relatório de tarefas.")
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div className={styles.content}>
                <div className={styles.card}>
                    <div className={styles.header}><MdOutlineFileDownload /><span>Exportar Relação de Tarefas</span></div>
                    <div className={styles.link}><NavLink to={`/${account_id}/reports/log`}>Acessar histórico de exportações</NavLink></div>
                    <div className={styles.body}>
                        <FormGroup labelText="Equipe"><Select multiple name="Equipe" placeholder="Buscar..." options={teams || []} selected={filters.teams || []} onChange={value => changeFilter("teams", value)} /></FormGroup>
                        <FormGroup labelText="Usuário"><Select multiple name="Usuário" placeholder="Buscar..." options={getUsersBySelectedTeams(filters.teams, users, teams)} selected={filters.users || []} onChange={value => changeFilter("users", value)} /></FormGroup>
                        <FormGroup labelText="Status"><Select multiple name="Status" placeholder="Buscar..." options={taskStatusOptions} selected={filters.status || []} onChange={value => changeFilter("status", value)} /></FormGroup>
                        <FormGroup labelText="Tipo"><Select multiple name="Tipo" placeholder="Buscar..." options={typesTask || []} selected={filters.typesTask || []} onChange={value => changeFilter("typesTask", value)} /></FormGroup>
                        <FormGroup labelText="Agendada para"><DatePicker multiple name="Agendada para" dateStart={filters.dateStart || ""} dateEnd={filters.dateEnd || ""} onChange={(dateStart, dateEnd) => setFilters(previous => ({ ...previous, dateStart, dateEnd }))} /></FormGroup>
                        <FormGroup labelText="Data de conclusão"><DatePicker multiple name="Data de conclusão" dateStart={filters.dateFinishStart || ""} dateEnd={filters.dateFinishEnd || ""} onChange={(dateFinishStart, dateFinishEnd) => setFilters(previous => ({ ...previous, dateFinishStart, dateFinishEnd }))} /></FormGroup>
                    </div>
                    <div className={styles.footer}><Button variant="primary" onClick={submit} disabled={loading}>Solicitar Relatório</Button></div>
                </div>
            </div>
            {loading && <Loading fullPage />}
        </>
    )
}

export default ReportDataTask
